export default "__VITE_ASSET__C6Aitt$t__"